/* eslint-disable i18next/no-literal-string */
import React, { ForwardedRef } from 'react'

import ProductFormDS from '@src/components/blocks/product-form-ds'
import { shouldUseDesignSystem } from '@src/utils/should-use-design-system'

import ProductFormLegacy from './product-form-legacy'
import { ProductFormProps } from './product-form.types'

// Re-export types and shared helpers so external consumers keep their import paths.
export type { PreOrderInfo, MadeToOrderInfo, VariantPurchaseInfo, ProductFormProps } from './product-form.types'
export {
  documentToReactComponentsTextOptions,
  KlarnaWrapper,
  renderProductOption,
  renderErrorMessage,
} from './product-form-shared'

// eslint-disable-next-line react/display-name
const ProductForm = React.forwardRef(function ProductFormEl(
  props: ProductFormProps,
  ref: ForwardedRef<HTMLDivElement | null>,
) {
  if (shouldUseDesignSystem()) {
    return <ProductFormDS {...props} ref={ref} />
  }
  return <ProductFormLegacy {...props} ref={ref} />
})

export { ProductForm }
export default ProductForm
/* eslint-enable i18next/no-literal-string */
